/**
 * Resolve a stored relative asset path (e.g. "assets/images/logo/x.png" or
 * "upload/content/y.jpg") to a browser-loadable URL. Absolute URLs and
 * already-rooted paths are returned untouched.
 *
 * Editable content stores paths without a leading slash so uploaded files
 * (upload/…) and bundled assets (assets/…) are handled uniformly; the root
 * .htaccess rewrites /upload/* and /assets/* to the right place.
 */
export function assetUrl(path) {
  if (!path) return '';
  const str = String(path);
  if (/^https?:\/\//i.test(str)) return str;
  return `/${str.replace(/^\/+/, '')}`;
}
